<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->
<template>
  <v-container
    fluid
    class="bg-landing h-100"
  >
    <v-row dense>
      <v-col cols="12">
        <v-container
          class="mx-auto"
          style="max-width: 650px;"
        >
          <v-row dense>
            <v-col cols="12">
              <div style="height: 50px;" />
            </v-col>
            <v-col cols="12">
              <v-toolbar color="primary">
                <v-toolbar-title>{{ parseAttribute('homePage.header_btn') }}</v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col cols="12">
              <guest-order-form />
            </v-col>
            <v-col cols="12">
              <div style="height: 50px;" />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { MetaInfoMixin } from '@mixins'
import GuestOrderForm from '@components/order/GuestOrderForm.vue'

export default {
  name: 'ApplyPage',
  components: { GuestOrderForm },
  // extends: SettingComponent,
  mixins: [MetaInfoMixin],
  data: () => ({})
}
</script>
